// The app-shell palette used by Layout, Footer, and GlobalStyles. Each mini-app
// under libs/* keeps its OWN brand palette; this is deliberately just the
// site-shell tokens.
export const COLOR = {
  BLUE: '#337AB7',
  ORANGE: '#F97168',
  LIGHT_GREY: '#F2F2F2',
  YELLOW: '#FFC600',
  LIGHT_YELLOW: '#FFF3D8',
  WHITE: '#FFFFFF',
  BLACK: '#000000',
};
